<template>
  <div class="card dorm-list">
    <div class="dorm-list-header">
      <h3>校舍搜索</h3>
      <div class="search-row">
        <input
          v-model="keyword"
          type="text"
          placeholder="请输入名称"
        />
        <button class="btn btn-primary" @click="goAlarms">报警记录</button>
        <button class="btn btn-primary" style="margin-left:0px" @click="goToModifyTerminal">修改数据</button>
      </div>
    </div>

    <div class="dorm-scroll">
      <div
        v-for="dorm in filteredDorms"
        :key="dorm.id"
        :class="[ 'dorm-item', dorm.id === selectedId ? 'dorm-item--active' : '' ]"
        @click="$emit('select', dorm)"
        
      >
        <div class="dorm-text"  :style="{ opacity: dorm.status !== 1 ? 0.4 : 1 }">
          <span class="dorm-name">{{ dorm.deviceName }}</span>
          <span class="dorm-meta">{{ dorm.status === 1 ? '终端在线' : '终端离线' }}</span>
        </div>
        <span class="dorm-arrow">›</span>
      </div>
    </div>

    <div class="hint">
      可通过搜索宿舍名称或状态（输入“在线”查找在线宿舍，输入“离线”查找离线宿舍），单击选中后导入右侧某个编组。
    </div>
  </div>
</template>

<script>

export default {
  name: 'DormList',
  props: {
    dorms: {
      type: Array,
      default: () => []
    },
    selectedId: {
      type: [String, Number, null],
      default: null
    }
  },
  data() {
    return {
      keyword: ''
    }
  },
  computed: {
    filteredDorms() {
      if (!this.keyword) return this.dorms;
      
      const k = this.keyword.trim().toLowerCase(); // 转小写以便不区分大小写

      // 过滤包含设备名和在线/离线状态的项
      return this.dorms.filter(dorm => {
        const isOnline = dorm.status === 1 && k.includes('在线');  // 检查是否包含 "在线"
        const isOffline = dorm.status === 0 && k.includes('离线');  // 检查是否包含 "离线"
        const isNameMatch = dorm.deviceName && dorm.deviceName.toLowerCase().includes(k);  // 检查名称匹配

        return isNameMatch || isOnline || isOffline;  // 只要匹配名称或状态
      });
    }
  },
  methods: {
    goAlarms() {
      this.$router.push({
        name: 'AlarmRecords',
        params: { group: this.group }
      })
    },
    goToModifyTerminal() {
      this.$router.push({ name: 'ModifyTerminal' });
    }
  }
}
</script>

<style scoped>
.dorm-list-header {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 12px;
}

.dorm-list-header h3 {
  font-size: 16px;
  font-weight: 600;
  position: relative;
  padding-left: 10px;
  color: #e5e7eb;
}

.dorm-list-header h3::before {
  content: '';
  position: absolute;
  left: 0;
  top: 3px;
  bottom: 3px;
  width: 3px;
  border-radius: 999px;
  background: linear-gradient(180deg, #60a5fa, #1d4ed8);
}

.search-row {
  display: flex;
  gap: 10px;
}

.dorm-scroll {
  margin-top: 10px;
  max-height: 420px;
  overflow-y: auto;
  border-radius: 10px;
  background: rgba(15, 23, 42, 0.9);
  box-shadow: inset 0 0 0 1px rgba(31, 41, 55, 0.9);
}

.dorm-scroll::-webkit-scrollbar {
  display: none;  /* 隐藏垂直和水平滚动条 */
}

.dorm-item {
  padding: 9px 14px;
  font-size: 14px;
  cursor: pointer;
  border-bottom: 1px solid rgba(31, 41, 55, 1);
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #e5e7eb;
}

.dorm-item:last-child {
  border-bottom: none;
}

.dorm-text {
  display: flex;
  flex-direction: column;
}

.dorm-name {
  font-weight: 500;
}

.dorm-meta {
  font-size: 12px;
  color: #9ca3af;
}

.dorm-arrow {
  font-size: 18px;
  color: #6b7280;
}

.dorm-item:hover {
  background: rgba(30, 64, 175, 0.35);
}

.dorm-item--active {
  background: linear-gradient(90deg, rgba(37, 99, 235, 0.7), rgba(30, 64, 175, 0.9));
  color: #f9fafb;
  font-weight: 500;
}

.hint {
  margin-top: 10px;
  font-size: 12px;
  color: #9ca3af;
}

/* 手机：搜索行竖排 */
@media (max-width: 600px) {
  .search-row {
    flex-direction: column;
  }
  .search-row .btn {
    width: 100%;
  }
}
</style>
